export default __webpack_public_path__ + "static/media/Belt of the Dark Messenger.00351a27.jpg";